import Vue from "vue";
import "./plugins/fontawesome";
import App from "@/App.vue";
import router from "@/router";
import "@/styles/app.scss";

////////////  BOSTRAP  ///////////////////////
import BootstrapVue, {
  ButtonGroupPlugin,
  ButtonPlugin,
  DropdownPlugin,
  FormPlugin,
  IconsPlugin,
  LayoutPlugin,
  ModalPlugin,
  OverlayPlugin,
  TablePlugin,
  ToastPlugin,
} from "bootstrap-vue";
//// Pinia container.
import { createPinia, PiniaVuePlugin } from "pinia";
import VueCookies from "vue-cookies";
////
import i18n from "@/i18n";
///////////////////
import VueNoty from "vuejs-noty";
////////////////////////////////////////////////////////
import VueLodash from "vue-lodash";
import lodash from "lodash";
/////////////
//////////////////////////////////////////////
import jwt_decode from "jwt-decode";
import Loading from "vue-loading-overlay";
/////////////
import VueSidebarMenu from "vue-sidebar-menu";
////////////////////////////////////
import vueDebounce from "vue-debounce";
///////////////////////////////////////////////////
import Vuelidate from "vuelidate";
import VueMultiselect from "vue-multiselect";

Vue.use(
  FormPlugin,
  OverlayPlugin,
  ButtonGroupPlugin,
  ButtonPlugin,
  IconsPlugin,
  ToastPlugin,
  TablePlugin,
  DropdownPlugin,
  ModalPlugin,
  LayoutPlugin
);
Vue.use(BootstrapVue);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
///////////////////////////////////////////
require("@/plugins/fontawesome");
////////////////////
Vue.use(VueCookies);
//////////////////////////////////////////////
window.$ = window.jQuery = require("jquery");
Vue.use(VueNoty, {
  layout: "topLeft",
  closeWith: ["button"],
});
Vue.use(VueLodash, { lodash: lodash });
let spinnerColor = "#80c6df";
if (
  window.$cookies?.get("LTI_JWT") &&
  !window.location.href.includes("admin")
) {
  const token = window.$cookies.get("LTI_JWT");
  let jwtDecoded = jwt_decode(token);
  if (jwtDecoded?.primaryColor) {
    spinnerColor = jwtDecoded.primaryColor;
  }
}
Vue.use(Loading, {
  // Pass props by their camelCased names
  color: spinnerColor,
  loader: "spinner",
  width: 128,
  height: 128,
  backgroundColor: "#ffffff",
  opacity: 0.5,
});
Vue.use(VueSidebarMenu);
Vue.use(vueDebounce);
///////////////////////////////////
const moment = require("moment");
require("moment/locale/es");
Vue.use(require("vue-moment"), {
  moment,
});
window.EventBus = new Vue();
window.moment = moment;

Vue.use(Vuelidate);

Vue.component("vue-multiselect", VueMultiselect.default);
/////////  MONTADO DE APLICACION ////////////
Vue.config.productionTip = false;

new Vue({
  history,
  router,
  i18n,
  pinia,
  render: (h) => h(App),
}).$mount("#app");

/**
 * Funciones que recalcula automaticamente el alto del iframe y envia un POST Message, utilizado por la plataforma
 */
const MIN_HEIGHT = 500;
const BORDER = 1;
const mainContent = document.getElementById("main-content");
const createRevisionModal = document.getElementById("sidebar-new");

function createResizePostData(height) {
  if (height < MIN_HEIGHT) height = MIN_HEIGHT;
  // eslint-disable-next-line
  return '{"subject":"lti.frameResize", "height":' + height + "}";
}

function forceResize(newHeight) {
  parent.postMessage(createResizePostData(newHeight), "*");
}

function getMarginTopAndBottom(element) {
  const height =
    parseInt(window.getComputedStyle(element).marginTop) +
    parseInt(window.getComputedStyle(element).marginBottom);
  return height;
}

function getPaddingTopAndBottom(element) {
  const height =
    parseInt(window.getComputedStyle(element).paddingTop) +
    parseInt(window.getComputedStyle(element).paddingBottom);
  return height;
}

function calculateHeightModal(modal) {
  const paddingPrincipalLti = document.getElementsByClassName(
    "principal_lti_container container-fluid"
  )[0];
  const elementsModal = modal.getElementsByClassName("b-sidebar-body")[0];
  return [...elementsModal.childNodes.values()]
    .filter((el) => el.offsetHeight !== undefined)
    .reduce(
      (acc, ele) => acc + ele.offsetHeight + getMarginTopAndBottom(ele),
      getPaddingTopAndBottom(elementsModal) +
        getPaddingTopAndBottom(paddingPrincipalLti)
    );
}

function calculateHeightSesionContent(mainContent) {
  const sessionContent = mainContent.firstElementChild;
  const pageControls = sessionContent.firstElementChild;
  const revisionesList = sessionContent.children[1];

  const heightSessionContent =
    pageControls.offsetHeight +
    revisionesList.scrollHeight +
    getMarginTopAndBottom(sessionContent);

  const footerContent = mainContent.children[1];
  let heightSessionFooter = 0;

  if (footerContent.scrollHeight !== undefined) {
    heightSessionFooter =
      footerContent.scrollHeight + getMarginTopAndBottom(footerContent);
  }

  return heightSessionContent + heightSessionFooter;
}

function setMainContentHeight(newHeight) {
  mainContent.style.height = newHeight + "px";
}

function changeMainContentHeight(mainContent) {
  let newHeightCreationModal = 0;
  let newHeightEditReviewModal = 0;
  if (createRevisionModal && createRevisionModal.style.display !== "none") {
    newHeightCreationModal = calculateHeightModal(createRevisionModal);
  } else {
    const modales = document.querySelectorAll(
      ".b-sidebar.shadow.b-sidebar-right.bg-white.text-dark.bb-offcanvas-panel:not([style='display: none;'])"
    );
    const modalVisible = Array.from(modales).filter((el) => {
      return el.style.display == "";
    });
    const selectedRevision = modalVisible[0];

    if (selectedRevision) {
      newHeightEditReviewModal = calculateHeightModal(selectedRevision);
    }
  }

  const newHeightSesionContent =
    mainContent != null ? calculateHeightSesionContent(mainContent) : 0;

  setMainContentHeight(
    Math.max(
      newHeightCreationModal + BORDER,
      newHeightEditReviewModal,
      newHeightSesionContent,
      MIN_HEIGHT
    )
  );
}

function changeHeightIFrame() {
  changeMainContentHeight(mainContent);
  let docHtml = document.documentElement;
  const difference = docHtml.offsetHeight - docHtml.clientHeight;
  if (
    docHtml.offsetHeight !== docHtml.clientHeight &&
    !(-BORDER <= difference && difference <= BORDER)
  ) {
    forceResize(docHtml.offsetHeight + BORDER);
  }
}
if (mainContent) {
  window.addEventListener("click", changeHeightIFrame);

  window.addEventListener("resize", changeHeightIFrame);

  window.addEventListener("mouseover", changeHeightIFrame);

  window.addEventListener("DOMContentLoaded", changeHeightIFrame);
}
